import useAuth from '@src/core/auth/components/auth0-wrapper';
import { LocaleTranslationKeysEnum } from '@src/core/i18n/locale-translation-keys.enum';
import { useCallback } from 'react';
import { ErrorPageTemplate } from 'swo-ciam-common-react';
import image from '../../../../../public/images/403.png';
import { RoutePathsEnum } from '../../route-paths.enum';

const Error403Component = () => {
  const { logout } = useAuth();

  const buttonClickHandler = useCallback(
    () => logout({ returnTo: window.location.origin }),
    [logout]
  );

  return (
    <ErrorPageTemplate
      items={[
        { key: LocaleTranslationKeysEnum.SwoErrorPages403Title },
        {
          key: LocaleTranslationKeysEnum.SwoErrorPages403SubTitle,
        },
        {
          key: LocaleTranslationKeysEnum.SwoErrorPages403Description,
        },
      ]}
      link={{ external: false, url: RoutePathsEnum.Home }}
      image={{ src: image, alt: LocaleTranslationKeysEnum.SwoErrorPages403ImgAlt }}
      button={{
        label: LocaleTranslationKeysEnum.SwoErrorPagesSharedActionsGoBack,
        placeholder: LocaleTranslationKeysEnum.SwoErrorPagesSharedActionsGoBack,
        onClick: buttonClickHandler,
      }}
      footerText={{
        key: LocaleTranslationKeysEnum.SwoErrorPagesSharedFooterText,
      }}
    />
  );
};

export default Error403Component;
